import $ from "jquery"
import {BillingSummaryReportInfo, TimeApprovalStatus} from 'constants'
import {ReportGroupingLevel} from '../constants'
import BillingSummaryReportEditConfigController from './BillingSummaryReportEditConfigController'
import DisplayedDataSelector from '../../controls/displayed_data_radiogroup_controls_bs_report'

export default class BillingSummaryReportEditFormConfigController extends BillingSummaryReportEditConfigController {}

BillingSummaryReportEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function(reportParameters) {
    var result = $.extend({}, reportParameters)

    if (!EnabledFeatures.BRA && DisplayedDataSelector.prototype.isBillingTimeSelectorOption(reportParameters.reportInfo))
        result.reportInfo = BillingSummaryReportInfo.TIME_ON_BILLABLE_TASKS

    if (!EnabledFeatures.UGR) {
        var groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(ReportGroupingLevel.USER_GROUP,
            [result.firstGroupingLevel, result.secondGroupingLevel],
            ReportGroupingLevel.USER
        )
        result.firstGroupingLevel = groupings[0]
        result.secondGroupingLevel = groupings[1]
    }
    if (!EnabledFeatures.TTA) {
        result.timeApprovalStatus = TimeApprovalStatus.BOTH
    }

    return result
}


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/BillingSummaryReportEditFormConfigController.js